export const calendarReminders = {
    deadline_days: new Date(2018, 1, 7),
    expected_deadline: new Date(2018, 1, 9),
    exam_day: new Date(2018, 1, 15),
    graduation: new Date(2018, 1, 25)
};


// WEBPACK FOOTER //
// ./src/data/calendarReminders.js